import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { slot: "content" }
const _hoisted_7 = { slot: "content" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { slot: "content" }
const _hoisted_11 = { slot: "content" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "ion-padding"
}
const _hoisted_14 = { class: "step-content" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  class: "step-label"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 0,
  class: "step-label ion-text-center"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "table-container" }
const _hoisted_24 = { class: "advertisement-table" }
const _hoisted_25 = { style: {"padding-left":"12px"} }
const _hoisted_26 = { class: "large-text" }
const _hoisted_27 = { style: {"padding-left":"16px","padding-right":"0"} }
const _hoisted_28 = { class: "large-text" }
const _hoisted_29 = ["src"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = ["src"]
const _hoisted_33 = ["src"]
const _hoisted_34 = ["src"]
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "large-text" }
const _hoisted_37 = { class: "small-text" }
const _hoisted_38 = { class: "large-text" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "table-container" }
const _hoisted_41 = ["src", "onClick"]

import { add, remove } from 'ionicons/icons';

// Vue reactivity
import { ref, defineComponent, computed, watch, reactive, onMounted } from 'vue';

// icons
import { close, arrowBack, checkmarkCircle, alertCircle, ellipsisHorizontal, ellipsisVertical, } from 'ionicons/icons';

// components
import { IonHeader, IonToolbar, IonTitle, IonContent, IonFooter, IonRow, IonCol,
        IonItem, IonLabel, IonIcon, IonButtons, IonButton, IonSpinner, IonList,
        IonCard, IonCardHeader, IonCardSubtitle, IonCardContent, IonPopover,
        IonAccordion, IonAccordionGroup, IonText, IonSegment, IonSegmentButton, IonChip,
        loadingController, modalController, alertController, } from '@ionic/vue';
import SessionStudentListModal from '@/components/modals/SessionStudentListModal.vue';
import SLPModal from '@/components/secondary/ABSLPModal.vue';
import UniEventsDetails from '@/components/client/UniEventsDetails.vue'
import ServiceModal from '@/components/modals/ServiceModal.vue';
import ActionAccordionGroup from '@/components/shared/ActionAccordionGroup.vue';

// composables / services
import { useI18n } from 'vue-i18n';
import { utils } from '@/composables/utils';
import { useStore } from '@/store';
import CommonService from '@/services/CommonService';

// methods or filters

export default /*@__PURE__*/_defineComponent({
  __name: 'ClientActionCardList',
  setup(__props) {

// Icons
const store = useStore();
const { t } = useI18n();
const { openModal, formatDate, openImageModal, getProxyImgLink, closeModal, } = utils();

//const loadingData = computed(() => store.state.loadingUser || store.state.loadingData || store.state.loadingSchoolUserData);
const loadingData = computed(() => store.state.loadingUser || store.state.loadingData);
const user = computed(() => store.state.user);
const userRelatedClient = computed(() => store.getters.userRelatedClient);
const clientHomeSlideImgUrl = ref(null);
const clientServices = computed(() => store.getters.getSecSchoolServicesByClientId(user.value.clientId || "c955c4b06"));
const clientUniSessions = computed(() => store.getters.getUniEventSessionsByClientId(user.value.clientId || "c955c4b06"));
const clientUniServices = computed(() => store.getters.getUniServicesByClientId(user.value.clientId || "c955c4b06"));
const allPrograms = computed(() => store.state.allPrograms);

const clientSessions = computed(() => store.getters.getSessionsByClientId(user.value.clientId));

const allSchools = computed<School[]>(() => store.state.schools); // All Schools
const getFormattedClientTargetBandRange = computed(() => {
  const { targetBands } = userRelatedClient.value || {};
  const bands = targetBands.sort();
  return `${bands[0]}-${bands[bands.length - 1]}`;
});
const numOfRegisteredClientTargetSchools = computed(() => {
  const { targetBands } = userRelatedClient.value || {};
  return allSchools.value.filter(s => targetBands?.includes(s.band) && s.numOfRegisteredTeachers > 0).length;
});
const numOfTotalClientTargetSchools = computed(() => {
  const { targetBands } = userRelatedClient.value || {};
  return allSchools.value.filter(s => targetBands?.includes(s.band)).length;
})

const selectedView = ref('prospective-students'); // Prospective / Existing students

const psView = reactive({
  type: 'create', // create or communicate winning features
  step: 2,
  yearDSE: 2026,
})

// Slides
const stepSlideImageUrls = reactive({});
const checkStepSlideLink = (stepKey) => {
  const slideLink = userRelatedClient.value[stepKey];
  return slideLink?.includes('docs.google.com/presentation');
}
const isImageLoaded = ref(false);
onMounted(async () => {
  const { homeSlideLink } = userRelatedClient.value;
  /*if (homeSlideLink) {
    CommonService.getSlideImageUrl(homeSlideLink).then(res => {
      clientHomeSlideImgUrl.value = res;
    })
  }*/

  setTimeout(async () => {
    for (const stepKey in userRelatedClient.value) {
      if (!stepKey.startsWith('create') || !checkStepSlideLink(stepKey)) continue;
      const slideLink = userRelatedClient.value[stepKey];
      stepSlideImageUrls[stepKey] = await CommonService.getSlideImageUrl(slideLink);
    }
    setTimeout(() => {
      isImageLoaded.value = true;
    }, 200);
  }, 200); 
})


const groupedSessions = (targetAnchorEventId) => {
  const obj = {};
  for (const session of clientSessions.value) {
    let group = ""
    const { startTimeStr, anchorEventId, status } = session;
    if (anchorEventId != targetAnchorEventId) continue;
    if (status == "Rejected") continue;
    if (new Date(startTimeStr) > new Date(+new Date() - 86400000)) {
      group = "future";
    } else {
      group = "past";
    }
    obj[group] = obj[group] || [];
    obj[group].push(session);
  }
  return obj;
}

const groupedUniSessions = () => {
  const obj = {};
  for (const session of clientUniSessions.value) {
    let group = ""
    const { startTimeStr, anchorEventId, status } = session;
    if (status == "Rejected") continue
    if (new Date(startTimeStr) > new Date(+new Date() - 86400000)){
      group = "future"
    } else {
      group = "past"
    }
    if (anchorEventId == 'workshop2'){
      session.displayGroupName = "Educated job seeking"
    } else if (anchorEventId == 'cc31fb5c1') {
      session.displayGroupName = "Guest lecture"
    } else {
      session.displayGroupName = ""
    }

    obj[group] = obj[group] || [];
    obj[group].push(session);
  }
  return obj;
}

// Modals
const openServiceModal = async (serviceId) => (await openModal(ServiceModal, { serviceId, isClientView: true, hideTeacherResponse: false }));
const openSessionStudentListModal = async (sessionId) => (await openModal(SessionStudentListModal, { sessionId }));
const openSessionUniStudentListModal = async (sessionId) => (await openModal(SessionStudentListModal, { sessionId, isStudentView: false, isShowUniStudents: true }));
const openSLPModal = async () => {
  const ev = store.getters.getLastAttendedSession;
  return await openModal(SLPModal, { ev, serviceId: ev?.serviceId, relatedProgramId: ev?.relatedProgramId, relatedClientId: user.value.clientId }, "", false)
}
const openUniEventDetails = async (sessionId) => (await openModal(UniEventsDetails, { sessionId }));
const openProposeDateModal = async () => (alert("Propose"));

const getClientPhotosByType = (type: any) => {
  const { clientPhotos } = userRelatedClient.value || {};
  return clientPhotos ? clientPhotos.filter(p => p.type == type) : [];
}

const openReportLink = () => {
  const currSelectedView = selectedView.value;
  window.open(userRelatedClient.value.longReportLink, '_blank');
  setTimeout(() => {
    selectedView.value = currSelectedView;
  }, 100)
}

// Client Sections
const getClientSectionsByGroup = (group) => {
  const sections = userRelatedClient.value.clientSections.filter(s => s.group == group);
  return sections.map(s => {
    s.filteredItems = s.items.filter(item => item.yearDSE == psView.yearDSE);
    return s;
  });
};
const getTotalFilteredItemsNum = (filteredItems) => {
  return filteredItems.reduce((total, item) => total + Number(item.number || 0), 0)
}
const getTotalClientSectionItemNumByGroup = (group) => {
  return getClientSectionsByGroup(group).reduce((total, section) => total + getTotalFilteredItemsNum(section.filteredItems), 0);
}

// Program Statistics
const getProgramById = (programId) => (allPrograms.value.find(p => p.id == programId));
const getProgramHeader = (programId) => {
  const { jupasCode, institutionNameShort } = getProgramById(programId) || {};
  return `${jupasCode} ${institutionNameShort}`;
}
const getProgramName = (programId) => (getProgramById(programId)?.name);

// Video
function getYouTubeEmbedUrl(youtubeUrl) {
  if (youtubeUrl) {
    const match = youtubeUrl.match(/(?:v=|youtu\.be\/|embed\/|live\/|shorts\/)([^&?%#]{11})/);
    if (match && match[1]) {
      const videoId = match[1];
      return `https://www.youtube.com/embed/${videoId}`;
    }
  }
  return null;
}


return (_ctx: any,_cache: any) => {
  const _component_home_action_item = _resolveComponent("home-action-item")!

  return (loadingData.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonSpinner))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (clientHomeSlideImgUrl.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                style: {"width":"100%","cursor":"pointer"},
                src: clientHomeSlideImgUrl.value,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageModal)(clientHomeSlideImgUrl.value)))
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        (!user.value.isAdmin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (userRelatedClient.value.workServiceId)
                ? (_openBlock(), _createBlock(_unref(IonCard), {
                    key: 0,
                    class: "outer-card"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonAccordionGroup), { value: "F5" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonAccordion), {
                            style: {"--min-height":"24px"},
                            value: "F5"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonItem), {
                                lines: "full",
                                slot: "header",
                                color: "fdmtred"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonLabel), null, {
                                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                                      _createElementVNode("b", null, "4-hr workshop", -1)
                                    ])),
                                    _: 1,
                                    __: [7]
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonCard), { slot: "content" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonItem), {
                                    lines: "full",
                                    color: "light",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (openSLPModal())),
                                    button: "",
                                    detail: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                                          _createElementVNode("p", { style: {"color":"#888888"} }, [
                                            _createElementVNode("b", null, "SLP tool for students")
                                          ], -1)
                                        ])),
                                        _: 1,
                                        __: [8]
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(IonAccordionGroup), {
                                    multiple: true,
                                    value: ['coming']
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonAccordion), {
                                        value: "coming",
                                        key: "coming"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonItem), {
                                            slot: "header",
                                            color: "light"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                  _createElementVNode("p", { style: {"color":"#888888"} }, [
                                                    _createElementVNode("b", null, "Coming schedule")
                                                  ], -1)
                                                ])),
                                                _: 1,
                                                __: [9]
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createElementVNode("div", _hoisted_6, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedSessions('work-workshop-2')['future'], (session) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: session.id
                                              }, [
                                                _createVNode(_component_home_action_item, {
                                                  title: `${session.date} ${session.startTime} - ${session.status == 'TBC' ? 'Confirm' : session.status}`,
                                                  hideIcon: true,
                                                  onClick: ($event: any) => (session.status == 'Confirmed' ? openSessionStudentListModal(session.id) : openUniEventDetails(session.id)),
                                                  textColor: session.status == 'Confirmed' ? 'success' : 'danger'
                                                }, null, 8, ["title", "onClick", "textColor"])
                                              ]))
                                            }), 128)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientServices.value, (service) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: service.id
                                              }, [
                                                (service.nature == 'Workshop')
                                                  ? (_openBlock(), _createBlock(_component_home_action_item, {
                                                      key: 0,
                                                      title: `Workshop at university campus - Define date`,
                                                      hideIcon: true,
                                                      onClick: ($event: any) => (openServiceModal(service.id)),
                                                      textColor: 'danger'
                                                    }, null, 8, ["onClick"]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(IonAccordion), {
                                        value: "past",
                                        key: "past"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonItem), {
                                            slot: "header",
                                            color: "light"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                  _createElementVNode("p", { style: {"color":"#888888"} }, [
                                                    _createElementVNode("b", null, "Past participation")
                                                  ], -1)
                                                ])),
                                                _: 1,
                                                __: [10]
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createElementVNode("div", _hoisted_7, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedSessions('work-workshop-2')['past'], (session) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: session.id
                                              }, [
                                                _createVNode(_component_home_action_item, {
                                                  title: `${session.date} ${session.startTime}`,
                                                  hideIcon: true,
                                                  onClick: ($event: any) => (openSessionStudentListModal(session.id))
                                                }, null, 8, ["title", "onClick"])
                                              ]))
                                            }), 128))
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(IonToolbar), { class: "sticky-toolbar" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSegment), {
                    class: "view-switcher",
                    mode: "ios",
                    modelValue: selectedView.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedView).value = $event)),
                    scrollable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonSegmentButton), { value: "prospective-students" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { class: "no-text-transform" }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode("Prospective students")
                            ])),
                            _: 1,
                            __: [11]
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonSegmentButton), { value: "existing-students" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { class: "no-text-transform" }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode("Existing students")
                            ])),
                            _: 1,
                            __: [12]
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonSegmentButton), {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (openReportLink()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { class: "no-text-transform" }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode("Report")
                            ])),
                            _: 1,
                            __: [13]
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (selectedView.value == 'existing-students')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (userRelatedClient.value.jobEXName)
                      ? (_openBlock(), _createBlock(_unref(IonCard), {
                          key: 0,
                          class: "outer-card"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonAccordionGroup), { value: "undergraduate" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonAccordion), {
                                  style: {"--min-height":"24px"},
                                  value: "undergraduate"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonItem), {
                                      lines: "full",
                                      slot: "header",
                                      color: "fdmtred"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonLabel), null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("b", null, _toDisplayString(userRelatedClient.value.department) + "-specific career training", 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonCard), { slot: "content" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonAccordionGroup), {
                                          multiple: true,
                                          value: ['coming']
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonAccordion), {
                                              value: "coming",
                                              key: "coming"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(IonItem), {
                                                  slot: "header",
                                                  color: "light"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                        _createElementVNode("p", { style: {"color":"#888888"} }, [
                                                          _createElementVNode("b", null, "Coming")
                                                        ], -1)
                                                      ])),
                                                      _: 1,
                                                      __: [14]
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createElementVNode("div", _hoisted_10, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedUniSessions()['future'], (session) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: session.id
                                                    }, [
                                                      _createVNode(_component_home_action_item, {
                                                        title: `${session.displayGroupName} [${session.date} ${session.startTime}] - ${session.status == 'TBC' ? 'Confirm' : session.status}`,
                                                        hideIcon: true,
                                                        onClick: ($event: any) => (openUniEventDetails(session.id)),
                                                        textColor: session.status == 'Confirmed' ? 'success' : 'danger'
                                                      }, null, 8, ["title", "onClick", "textColor"])
                                                    ]))
                                                  }), 128)),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientUniServices.value, (service) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: service.id
                                                    }, [
                                                      _createVNode(_component_home_action_item, {
                                                        title: `${service.name} - Define date`,
                                                        hideIcon: true,
                                                        onClick: ($event: any) => (openServiceModal(service.id)),
                                                        textColor: 'danger'
                                                      }, null, 8, ["title", "onClick"])
                                                    ]))
                                                  }), 128))
                                                ])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_unref(IonAccordion), {
                                              value: "past",
                                              key: "past"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(IonItem), {
                                                  slot: "header",
                                                  color: "light"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                                                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                        _createElementVNode("p", { style: {"color":"#888888"} }, [
                                                          _createElementVNode("b", null, "Past")
                                                        ], -1)
                                                      ])),
                                                      _: 1,
                                                      __: [15]
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createElementVNode("div", _hoisted_11, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedUniSessions()['past'], (session) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: session.id
                                                    }, [
                                                      _createVNode(_component_home_action_item, {
                                                        title: `${session.displayGroupName} [${session.date} ${session.startTime}]`,
                                                        hideIcon: true,
                                                        onClick: ($event: any) => (openSessionUniStudentListModal(session.id))
                                                      }, null, 8, ["title", "onClick"])
                                                    ]))
                                                  }), 128))
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_unref(IonToolbar), { class: "sticky-toolbar" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonSegment), {
                          class: "red-indicator-segment",
                          mode: "ios",
                          modelValue: psView.type,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((psView.type) = $event)),
                          scrollable: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonSegmentButton), { value: "create" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonLabel), { class: "no-text-transform" }, {
                                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                                    _createElementVNode("b", null, "Create", -1),
                                    _createTextVNode("  "),
                                    _createElementVNode("small", null, "winning features", -1)
                                  ])),
                                  _: 1,
                                  __: [16]
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonSegmentButton), { value: "communicate" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonLabel), { class: "no-text-transform" }, {
                                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                                    _createElementVNode("b", null, "Communicate", -1),
                                    _createTextVNode("  "),
                                    _createElementVNode("small", null, "winning features", -1)
                                  ])),
                                  _: 1,
                                  __: [17]
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_unref(IonToolbar), { class: "sticky-toolbar" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonSegment), {
                          class: "blue-indicator-segment",
                          mode: "ios",
                          modelValue: psView.yearDSE,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((psView.yearDSE) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([2025, 2026, 2027], (year) => {
                              return _createVNode(_unref(IonSegmentButton), {
                                key: year,
                                value: year
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonLabel), null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("DSE " + _toDisplayString(year), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, psView.type == 'communicate']
                    ]),
                    (psView.type == 'create')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_unref(IonRow), { class: "steps-container" }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Competing programs', 'Pre-campaign interest', 'Winning features', 'Hypothetical program', 'Graduate profession', 'Video script', 'Video'], (step, i) => {
                                return _createVNode(_unref(IonCol), {
                                  key: i,
                                  size: "auto",
                                  onClick: ($event: any) => (psView.step = i + 1)
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(['step', psView.step == i + 1 ? 'active' : ''])
                                    }, [
                                      _createElementVNode("div", _hoisted_14, _toDisplayString(i + 1) + ". " + _toDisplayString(step), 1)
                                    ], 2)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              }), 64))
                            ]),
                            _: 1
                          }),
                          (psView.step >= 1 && psView.step <= 6)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                (checkStepSlideLink(`createStep${psView.step}`))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      (isImageLoaded.value)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            style: {"width":"100%","cursor":"pointer"},
                                            src: stepSlideImageUrls[`createStep${psView.step}`],
                                            referrerPolicy: "no-referrer",
                                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(openImageModal)(stepSlideImageUrls[`createStep${psView.step}`])))
                                          }, null, 8, _hoisted_17))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(userRelatedClient.value[`createStep${psView.step}`]), 1))
                              ]))
                            : _createCommentVNode("", true),
                          (psView.step == 7)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                (getYouTubeEmbedUrl(userRelatedClient.value[`createStep${psView.step}`]))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      _createElementVNode("iframe", {
                                        style: {"width":"100%","height":"380px"},
                                        src: getYouTubeEmbedUrl(userRelatedClient.value[`createStep${psView.step}`]),
                                        frameborder: "0",
                                        allowfullscreen: ""
                                      }, null, 8, _hoisted_21)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("table", _hoisted_24, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_25, [
                                    _createElementVNode("span", _hoisted_26, "Band " + _toDisplayString(getFormattedClientTargetBandRange.value) + " schools", 1),
                                    _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                    _cache[19] || (_cache[19] = _createElementVNode("small", null, "with WhatsApp-connected principals, teachers & students", -1))
                                  ]),
                                  _createElementVNode("td", _hoisted_27, [
                                    _createElementVNode("span", _hoisted_28, _toDisplayString(numOfRegisteredClientTargetSchools.value), 1),
                                    _createTextVNode(" / ~" + _toDisplayString(numOfTotalClientTargetSchools.value), 1),
                                    _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                                    _createElementVNode("small", null, "(~" + _toDisplayString((numOfRegisteredClientTargetSchools.value / numOfTotalClientTargetSchools.value * 100).toFixed(0)) + "%)", 1)
                                  ])
                                ])
                              ])
                            ]),
                            _createVNode(ActionAccordionGroup, {
                              "no-accordion": false,
                              "header-color": 'primary',
                              "no-padding": true
                            }, {
                              header: _withCtx(() => [
                                _createVNode(_unref(IonItem), {
                                  lines: "full",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                        _createElementVNode("span", { class: "large-text" }, "Reach", -1),
                                        _createElementVNode("br", null, null, -1),
                                        _createElementVNode("span", { class: "small-text" }, "Assembly video sharing, WhatsApp survey enabled by school-signed MOUs", -1)
                                      ])),
                                      _: 1,
                                      __: [21]
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getClientSectionsByGroup('Reach'), (section) => {
                                  return (_openBlock(), _createBlock(ActionAccordionGroup, {
                                    key: section.id,
                                    "no-accordion": false,
                                    "header-color": 'fdmtblue',
                                    "no-padding": false
                                  }, {
                                    header: _withCtx(() => [
                                      _createVNode(_unref(IonItem), {
                                        lines: "full",
                                        color: "fdmtblue"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonLabel), { class: "medium-text" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(section.title), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_unref(IonLabel), {
                                            slot: "end",
                                            class: "large-text"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(getTotalFilteredItemsNum(section.filteredItems)), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.filteredItems, (item) => {
                                        return (_openBlock(), _createBlock(ActionAccordionGroup, {
                                          key: item.id,
                                          "no-accordion": !item.items?.length && !item.photo1Link && !item.photo2Link,
                                          "header-color": 'fdmtgrey',
                                          "no-padding": true
                                        }, {
                                          header: _withCtx(() => [
                                            _createVNode(_unref(IonItem), {
                                              class: "ion-padding-start",
                                              lines: "full",
                                              color: "fdmtgrey"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(IonLabel), {
                                                  class: "small-text",
                                                  style: {"white-space":"pre-line !important"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.title), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_unref(IonLabel), {
                                                  slot: "end",
                                                  class: "large-text"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.number), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("div", null, [
                                              (item.description)
                                                ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(IonLabel), {
                                                        class: "ion-padding-start",
                                                        style: {"white-space":"pre-line !important"}
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(item.description), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : _createCommentVNode("", true),
                                              _createVNode(_unref(IonRow), null, {
                                                default: _withCtx(() => [
                                                  (item.photo1Link)
                                                    ? (_openBlock(), _createBlock(_unref(IonCol), { key: 0 }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("img", {
                                                            src: item.photo1Link
                                                          }, null, 8, _hoisted_29)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : _createCommentVNode("", true),
                                                  (item.photo2Link)
                                                    ? (_openBlock(), _createBlock(_unref(IonCol), { key: 1 }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("img", {
                                                            src: item.photo2Link
                                                          }, null, 8, _hoisted_30)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              (item.items?.length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (nestedItem) => {
                                                      return (_openBlock(), _createBlock(_unref(IonItem), {
                                                        key: nestedItem.id
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(IonLabel), { class: "ion-padding-start" }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(nestedItem.title), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          _createVNode(_unref(IonLabel), {
                                                            slot: "end",
                                                            class: "large-text",
                                                            style: {"padding-right":"60px"}
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(nestedItem.number), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    }), 128))
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["no-accordion"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }),
                            _createVNode(ActionAccordionGroup, {
                              "no-accordion": false,
                              "header-color": 'primary',
                              "no-padding": true
                            }, {
                              header: _withCtx(() => [
                                _createVNode(_unref(IonItem), {
                                  lines: "full",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), { class: "small-text ion-no-margin" }, {
                                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                                        _createTextVNode("University visit, school visit, Zoom arranged voluntarily by teachers")
                                      ])),
                                      _: 1,
                                      __: [22]
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getClientSectionsByGroup('School-arranged'), (section) => {
                                  return (_openBlock(), _createBlock(ActionAccordionGroup, {
                                    key: section.id,
                                    "no-accordion": false,
                                    "header-color": 'fdmtblue',
                                    "no-padding": false
                                  }, {
                                    header: _withCtx(() => [
                                      _createVNode(_unref(IonItem), {
                                        lines: "full",
                                        color: "fdmtblue"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonLabel), { class: "medium-text" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(section.title), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_unref(IonLabel), {
                                            slot: "end",
                                            class: "large-text"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(getTotalFilteredItemsNum(section.filteredItems)), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.filteredItems, (item) => {
                                        return (_openBlock(), _createBlock(ActionAccordionGroup, {
                                          key: item.id,
                                          "no-accordion": false,
                                          "header-color": 'fdmtgrey',
                                          "no-padding": true
                                        }, {
                                          header: _withCtx(() => [
                                            _createVNode(_unref(IonItem), {
                                              class: "ion-padding-start",
                                              lines: "full",
                                              color: "fdmtgrey"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(IonLabel), { class: "small-text" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.title), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_unref(IonLabel), {
                                                  slot: "end",
                                                  class: "large-text"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.number), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonRow), null, {
                                              default: _withCtx(() => [
                                                (item.photo1Link)
                                                  ? (_openBlock(), _createBlock(_unref(IonCol), { key: 0 }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("img", {
                                                          src: item.photo1Link
                                                        }, null, 8, _hoisted_32)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true),
                                                (item.photo2Link)
                                                  ? (_openBlock(), _createBlock(_unref(IonCol), { key: 1 }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("img", {
                                                          src: item.photo2Link
                                                        }, null, 8, _hoisted_33)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }),
                            _createVNode(ActionAccordionGroup, {
                              "no-accordion": false,
                              "header-color": 'mediumblue',
                              "no-padding": true,
                              style: {"padding-left":"24px"}
                            }, {
                              header: _withCtx(() => [
                                _createVNode(_unref(IonItem), {
                                  lines: "full",
                                  color: "mediumblue"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                                        _createElementVNode("span", { class: "large-text" }, "Return", -1),
                                        _createElementVNode("br", null, null, -1),
                                        _createElementVNode("span", { class: "small-text" }, "University workshop, visit enrolled voluntarily by students", -1)
                                      ])),
                                      _: 1,
                                      __: [23]
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getClientSectionsByGroup('Return'), (section) => {
                                  return (_openBlock(), _createBlock(ActionAccordionGroup, {
                                    key: section.id,
                                    "no-accordion": false,
                                    "header-color": 'fdmtblue',
                                    "no-padding": false
                                  }, {
                                    header: _withCtx(() => [
                                      _createVNode(_unref(IonItem), {
                                        lines: "full",
                                        color: "fdmtblue"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonLabel), { class: "medium-text" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(section.title), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_unref(IonLabel), {
                                            slot: "end",
                                            class: "large-text"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(getTotalFilteredItemsNum(section.filteredItems)), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.filteredItems, (item) => {
                                        return (_openBlock(), _createBlock(ActionAccordionGroup, {
                                          key: item.id,
                                          "no-accordion": false,
                                          "header-color": item.sessionId ? 'fdmtgrey' : 'fdmtgrey',
                                          "no-padding": true
                                        }, {
                                          header: _withCtx(() => [
                                            (!!item.sessionId)
                                              ? (_openBlock(), _createBlock(_unref(IonItem), {
                                                  key: 0,
                                                  class: "ion-padding-start",
                                                  lines: "full",
                                                  color: "fdmtgrey",
                                                  onClick: _withModifiers(($event: any) => (openSessionStudentListModal(item.sessionId)), ["stop"]),
                                                  button: ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(IonLabel), null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.title), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_unref(IonLabel), {
                                                      slot: "end",
                                                      class: "large-text"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.number), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : (_openBlock(), _createBlock(_unref(IonItem), {
                                                  key: 1,
                                                  class: "ion-padding-start",
                                                  lines: "full",
                                                  color: "fdmtgrey"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(IonLabel), null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.title), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_unref(IonLabel), {
                                                      slot: "end",
                                                      class: "large-text"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.number), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonRow), null, {
                                              default: _withCtx(() => [
                                                (item.photo1Link)
                                                  ? (_openBlock(), _createBlock(_unref(IonCol), { key: 0 }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("img", {
                                                          src: item.photo1Link
                                                        }, null, 8, _hoisted_34)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true),
                                                (item.photo2Link)
                                                  ? (_openBlock(), _createBlock(_unref(IonCol), { key: 1 }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("img", {
                                                          src: item.photo2Link
                                                        }, null, 8, _hoisted_35)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["header-color"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }),
                            _createVNode(ActionAccordionGroup, {
                              "no-accordion": false,
                              "header-color": 'lightblue',
                              "no-padding": true,
                              style: {"padding-left":"48px"}
                            }, {
                              header: _withCtx(() => [
                                _createVNode(_unref(IonItem), {
                                  lines: "full",
                                  color: "lightblue"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                                        _createElementVNode("span", { class: "large-text" }, "Choice", -1),
                                        _createElementVNode("br", null, null, -1),
                                        _createElementVNode("span", { class: "small-text" }, "as estimated by students’ choices in pre-JUPAS school counselling", -1)
                                      ])),
                                      _: 1,
                                      __: [24]
                                    }),
                                    _createVNode(_unref(IonLabel), {
                                      slot: "end",
                                      class: "ion-text-right"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userRelatedClient.value.allRelatedProgramIds, (programId) => {
                                  return _withDirectives((_openBlock(), _createBlock(ActionAccordionGroup, {
                                    key: programId,
                                    "no-accordion": false,
                                    "header-color": 'lightblue',
                                    "no-padding": true
                                  }, {
                                    header: _withCtx(() => [
                                      _createVNode(_unref(IonItem), {
                                        lines: "full",
                                        color: "lightblue"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonLabel), null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", _hoisted_36, _toDisplayString(getProgramHeader(programId)), 1),
                                              _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                                              _createElementVNode("span", _hoisted_37, _toDisplayString(getProgramName(programId)), 1)
                                            ]),
                                            _: 2,
                                            __: [25]
                                          }, 1024),
                                          _createVNode(_unref(IonLabel), {
                                            slot: "end",
                                            class: "ion-text-right"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", _hoisted_38, _toDisplayString(getProgramById(programId)?.groupedNumOfA1B3[psView.yearDSE]), 1),
                                              _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                                              _cache[27] || (_cache[27] = _createElementVNode("small", null, "A1-B3", -1))
                                            ]),
                                            _: 2,
                                            __: [26,27]
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)), [
                                    [_vShow, getProgramById(programId)]
                                  ])
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                          _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                          _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
                          _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                          _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
                          _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
                          _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                          _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                          false
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _cache[29] || (_cache[29] = _createStaticVNode("<div class=\"table-container\" data-v-1d87eda5><table class=\"advertisement-table\" data-v-1d87eda5><thead data-v-1d87eda5><tr data-v-1d87eda5><th data-v-1d87eda5>Advertisement</th><th data-v-1d87eda5></th><th data-v-1d87eda5>Click <small data-v-1d87eda5>(since 2024 Sep)</small></th><th data-v-1d87eda5>Circulation</th></tr></thead><tbody data-v-1d87eda5><tr data-v-1d87eda5><td data-v-1d87eda5>2024 Nov 18</td><td data-v-1d87eda5>Nursing<br data-v-1d87eda5>Healthcare</td><td class=\"highlight-cell\" data-v-1d87eda5>25<br data-v-1d87eda5>30</td><td data-v-1d87eda5>1000<br data-v-1d87eda5>-</td></tr></tbody></table></div><div class=\"table-container\" data-v-1d87eda5><table class=\"advertisement-table\" data-v-1d87eda5><thead data-v-1d87eda5><tr data-v-1d87eda5><th data-v-1d87eda5>Promotional survey</th><th data-v-1d87eda5></th><th data-v-1d87eda5>Responses</th><th data-v-1d87eda5></th></tr></thead><tbody data-v-1d87eda5><tr data-v-1d87eda5><td data-v-1d87eda5>2024 Sep 13 (F5)</td><td class=\"ion-text-right\" data-v-1d87eda5>XX Will: X<br data-v-1d87eda5>Will not: Y</td><td class=\"highlight-cell\" data-v-1d87eda5>85</td><td data-v-1d87eda5>1000</td></tr></tbody></table></div>", 2)),
                                _createElementVNode("div", _hoisted_40, [
                                  _cache[28] || (_cache[28] = _createElementVNode("table", { class: "advertisement-table" }, [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, "Video shooting")
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("td", null, "2024 Sep 30 (F5)")
                                      ])
                                    ])
                                  ], -1)),
                                  (getClientPhotosByType('Shooting').length > 0)
                                    ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getClientPhotosByType('Shooting'), (p, idx) => {
                                            return (_openBlock(), _createBlock(_unref(IonCol), { key: idx }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  style: {"cursor":"pointer"},
                                                  src: p.photoLink,
                                                  onClick: ($event: any) => (_unref(openImageModal)(p.photoLink))
                                                }, null, 8, _hoisted_41)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _cache[30] || (_cache[30] = _createStaticVNode("<div class=\"table-container\" data-v-1d87eda5><table class=\"advertisement-table\" data-v-1d87eda5><thead data-v-1d87eda5><tr data-v-1d87eda5><th data-v-1d87eda5>In-person visits</th></tr></thead></table><div id=\"map\" style=\"height:400px;width:100%;\" data-v-1d87eda5></div></div><div class=\"table-container\" data-v-1d87eda5><table class=\"advertisement-table\" data-v-1d87eda5><thead data-v-1d87eda5><tr data-v-1d87eda5><th data-v-1d87eda5>2-hr visit</th><th data-v-1d87eda5>Participants</th></tr></thead><tbody data-v-1d87eda5><tr data-v-1d87eda5><td data-v-1d87eda5>2026 Feb X</td><td data-v-1d87eda5>TBC</td></tr><tr data-v-1d87eda5><td data-v-1d87eda5>2025 Sep X</td><td data-v-1d87eda5>TBC</td></tr><tr data-v-1d87eda5><td data-v-1d87eda5>2025 Jan 20</td><td data-v-1d87eda5>27</td></tr><tr data-v-1d87eda5><td data-v-1d87eda5>2024 Sep 30</td><td data-v-1d87eda5>25</td></tr></tbody></table></div><div class=\"table-container\" data-v-1d87eda5><table class=\"advertisement-table\" data-v-1d87eda5><thead data-v-1d87eda5><tr data-v-1d87eda5><th data-v-1d87eda5>4-hr workshop</th><th data-v-1d87eda5>Participants</th></tr></thead><tbody data-v-1d87eda5><tr data-v-1d87eda5><td data-v-1d87eda5>2025 Jun 27</td><td data-v-1d87eda5>35</td></tr></tbody></table></div>", 3))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ]))
            ]))
      ]))
}
}

})